const enums = { status: ['Active', 'Created', 'Inactive', 'Deleted'] };

export default enums;
